import PropTypes from 'prop-types';
import React from 'react';
import BooleanField from '../BooleanField';
import DateField from '../DateField';
import DatetimeField from '../DatetimeField';
import LiteralConfirmationField from '../LiteralConfirmationField';
import BasicReadField from '../BasicReadField';
import { DATATYPES } from '../utils/constants';
import { Typography } from '@material-ui/core';

class ReportDatatypeDisplay extends React.Component {

  render() {

    const { datatype, value, lang, showDetail } = this.props;
    const valueText = value;

    if (lang) return <BasicReadField text={valueText} lang={lang} fullWidth />;

    switch (datatype) {

      case DATATYPES.DATE:
        return <DateField
          key={valueText}
          displayDatatype={showDetail}
          isReadOnly={true}
          date={valueText} />;
      case DATATYPES.DATETIME:
        return <DatetimeField
          key={valueText}
          displayDatatype={showDetail}
          isReadOnly={true}
          dateTime={valueText} />;
      case DATATYPES.BOOLEAN:
        return <BooleanField
          key={valueText}
          displayDatatype={showDetail}
          isReadOnly={true}
          checked={typeof valueText === "boolean" ? valueText : valueText === "true"} />;
      case DATATYPES.STRING: case DATATYPES.ANYURI: case DATATYPES.INTEGER: case DATATYPES.NNINTEGER: case DATATYPES.DECIMAL: case DATATYPES.FLOAT: case DATATYPES.DOUBLE: case DATATYPES.LONG:
        return <LiteralConfirmationField
          dataTest={"test"}
          margin="dense"
          compact={true}
          displayDatatype={showDetail}
          text={valueText.toString()}
          datatype={datatype}
          canBeDeleted={false}
          isReadOnly={true}
        />;
      default:
    }

    // Custom datatype
    if (datatype)
      return <LiteralConfirmationField
        dataTest={"test"}
        margin="dense"
        compact={true}
        displayDatatype={showDetail}
        text={valueText.toString()}
        datatype={datatype}
        canBeDeleted={false}
        isReadOnly={true}
      />;

    return <Typography variant="body2">{valueText}</Typography>;

  }
}

ReportDatatypeDisplay.defaultProps = {
  datatype: DATATYPES.STRING,
  cardinalityAtMax: false,
  showDetail: false,
  canAddValues: true
};

ReportDatatypeDisplay.propTypes = {
  datatype: PropTypes.string,
  showDetail: PropTypes.bool,
  value: PropTypes.string.isRequired,
  lang: PropTypes.string,
};

export default ReportDatatypeDisplay;